import { render, staticRenderFns } from "./WeeklyTestMarkSheet.vue?vue&type=template&id=3d770a12&scoped=true"
import script from "./WeeklyTestMarkSheet.vue?vue&type=script&lang=js"
export * from "./WeeklyTestMarkSheet.vue?vue&type=script&lang=js"
import style0 from "./WeeklyTestMarkSheet.vue?vue&type=style&index=0&id=3d770a12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d770a12",
  null
  
)

export default component.exports